import React from "react";

const REPEAT = 6;

/**
 * A simple horizontal marquee using CSS keyframes (defined in index.css `.marquee-track`).
 */
export default function Marquee({ text = "PRO SKATE HOCKEY LEAGUE", separator = "·" }) {
  const items = Array.from({ length: REPEAT });
  return (
    <div className="relative overflow-hidden border-y border-white/10 py-5 bg-black/40" data-testid="brand-marquee">
      <div className="marquee-track">
        {items.map((_, i) => (
          <span
            key={`marquee-${text}-${i}`}
            className="font-display uppercase tracking-tight text-5xl md:text-7xl whitespace-nowrap px-8"
            style={{
              WebkitTextStroke: "1px rgba(255,255,255,0.25)",
              color: "transparent",
            }}
          >
            {text} <span className="text-pshl-electric/40 mx-2">{separator}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
